import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompaniesRoutingModule } from './companies-routing.module';
import { CompaniesDetailComponent } from './companies-detail/companies-detail.component';
import { CompaniesListComponent } from './companies-list/companies-list.component';
import { CompaniesService } from './companies.service';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  declarations: [
    CompaniesDetailComponent,
    CompaniesListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CompaniesRoutingModule,
    HttpClientModule,
    ButtonModule,
    InputTextModule,
    TableModule,
    CardModule,
    FontAwesomeModule,
    ConfirmDialogModule,
    DropdownModule
  ],
  exports:[
    CompaniesDetailComponent,
    CompaniesListComponent
  ],
  providers:[
    CompaniesService
  ]
})
export class CompaniesModule { }
